function Pagination({ currentPage, totalPages, onPageChange }) {
  const renderPages = () => {
    const pages = [];

    if (currentPage > 1) {
      pages.push(
        <button
          key="prev"
          className="w-8 h-8 flex items-center justify-center rounded-lg text-slate-400 hover:bg-white/5 transition-colors"
          onClick={() => onPageChange(currentPage - 1)}>
          ←
        </button>
      );
    }

    pages.push(
      <button
        key={1}
        onClick={() => onPageChange(1)}
        className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors ${
          currentPage === 1
            ? 'bg-sky-500 text-white'
            : 'text-slate-400 hover:bg-white/5'
        }`}>
        1
      </button>
    );

    if (currentPage > 4)
      pages.push(
        <span key="left-dot" className="w-8 h-8 flex items-center justify-center text-slate-500 text-sm">
          …
        </span>
      );

    for (
      let i = Math.max(2, currentPage - 2);
      i <= Math.min(totalPages - 1, currentPage + 2);
      i++
    ) {
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors ${
            currentPage === i
              ? 'bg-sky-500 text-white'
              : 'text-slate-400 hover:bg-white/5'
          }`}>
          {i}
        </button>
      );
    }

    if (currentPage < totalPages - 3)
      pages.push(
        <span key="right-dot" className="w-8 h-8 flex items-center justify-center text-slate-500 text-sm">
          …
        </span>
      );

    if (totalPages > 1) {
      pages.push(
        <button
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors ${
            currentPage === totalPages
              ? 'bg-sky-500 text-white'
              : 'text-slate-400 hover:bg-white/5'
          }`}>
          {totalPages}
        </button>
      );
    }

    if (currentPage < totalPages) {
      pages.push(
        <button
          key="next"
          className="w-8 h-8 flex items-center justify-center rounded-lg text-slate-400 hover:bg-white/5 transition-colors"
          onClick={() => onPageChange(currentPage + 1)}>
          →
        </button>
      );
    }

    return pages;
  };

  return (
    <div className="flex justify-center mt-5 items-center gap-1">
      {renderPages()}
    </div>
  );
}

export default Pagination;
